import React from 'react';
import { Row, Col, Spin } from 'antd';

const FullPageLoader = () => {
  return (
    <Row
      justify="center"
      align="middle"
      style={{
        height: '100vh', // Full height of the viewport
        width: '100vw', // Full width of the viewport
        backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional background color with transparency
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999, // Ensures it covers everything
      }}
    >
      <Col>
        <Spin size="large" />
      </Col>
    </Row>
  );
};

export default FullPageLoader;
